import { h } from 'preact';

interface SparklineProps {
  readonly data: readonly number[];
  readonly width?: number;
  readonly height?: number;
  readonly color?: string;
  readonly fillColor?: string;
  /** fill the parent width (viewBox keeps logical coords) */
  readonly stretch?: boolean;
}

export function Sparkline({
  data,
  width = 80,
  height = 24,
  color = 'var(--amber)',
  fillColor = 'rgba(253,176,34,0.10)',
  stretch = false,
}: SparklineProps) {
  if (data.length === 0) {
    return <svg width={width} height={height} />;
  }

  const padding = 2;
  const drawW = width - padding * 2;
  const drawH = height - padding * 2;

  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;

  const points = data.map((v, i) => {
    const x = padding + (i / Math.max(1, data.length - 1)) * drawW;
    const y = padding + drawH - ((v - min) / range) * drawH;
    return `${x},${y}`;
  });

  const polylinePoints = points.join(' ');
  const firstX = padding;
  const lastX = padding + drawW;
  const bottomY = height - padding;
  const polygonPoints = `${polylinePoints} ${lastX},${bottomY} ${firstX},${bottomY}`;

  return (
    <svg
      width={stretch ? '100%' : width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio={stretch ? 'none' : 'xMidYMid meet'}
      style={{ display: stretch ? 'block' : 'inline-block', verticalAlign: 'middle' }}
    >
      <polygon points={polygonPoints} fill={fillColor} stroke="none" />
      <polyline
        points={polylinePoints}
        fill="none"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        vector-effect={stretch ? 'non-scaling-stroke' : undefined}
      />
    </svg>
  );
}
